var _desc, _defs, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgArrowLeft(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "12px",
    height: "19px",
    viewBox: "0 0 12 19",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "Icons/PictureArrow Copy") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _desc || (_desc = /*#__PURE__*/React.createElement("desc", null, "Created with Sketch.")), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
    d: "M3.52838621,9.03381759 L10.214614,2.27732194 C10.3987199,2.09172976 10.5,1.84358825 10.5,1.57900191 C10.5,1.31426871 10.3987199,1.06627407 10.214614,0.880388257 L9.62872994,0.288666261 C9.44491459,0.102486825 9.19919786,0 8.93735178,0 C8.67550579,0 8.43007966,0.102486825 8.24611906,0.288666261 L0.285099336,8.33285465 C0.100412127,8.51932781 -0.000722623276,8.76849704 3.89272345e-06,9.0333771 C-0.000722623276,9.29943176 0.100266786,9.54830736 0.285099336,9.73492728 L8.23870827,17.7713337 C8.42266897,17.9575132 8.6680951,18.06 8.93008643,18.06 C9.19193242,18.06 9.43735856,17.9575132 9.6214645,17.7713337 L10.2072033,17.1796117 C10.5883476,16.7944786 10.5883476,16.1675176 10.2072033,15.7825313 L3.52838621,9.03381759 Z",
    id: "path-1"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "RHP-Search--Desktop-v2",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd",
    opacity: 0.300000012
  }, /*#__PURE__*/React.createElement("g", {
    id: "Profile-Friend-Request",
    transform: "translate(-1027.000000, -1580.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Icons/PictureArrow",
    transform: "translate(1033.500000, 1589.500000) scale(-1, 1) translate(-1033.500000, -1589.500000) translate(1023.000000, 1579.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "colour/mid-grey",
    transform: "translate(5.880000, 1.680000)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask-2",
    fill: "white"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#path-1"
  })), /*#__PURE__*/React.createElement("use", {
    id: "Mask",
    fill: "#FFFFFF",
    fillRule: "nonzero",
    transform: "translate(5.250000, 9.030000) scale(-1, 1) translate(-5.250000, -9.030000) ",
    xlinkHref: "#path-1"
  }), /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask-2)",
    fill: "#A5A5A5"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(-4.200000, -0.420000)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 0,
    width: 19,
    height: 19
  })))))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgArrowLeft);
export default __webpack_public_path__ + "static/media/arrowLeft.d309edf85a3f4fa86f7945622537fba3.svg";
export { ForwardRef as ReactComponent };